import { render, staticRenderFns } from "./leadsuList.vue?vue&type=template&id=7312fe63&"
import script from "./leadsuList.vue?vue&type=script&lang=js&"
export * from "./leadsuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports